<template>
  <div class="page-container">
    <page-header>
      <template slot="header-content"></template>
    </page-header>
    <div class="dashboard-container">
      <div class="page-card">
        <div class="page-card-header">
          <span>{{ $route.meta.title }}</span>
        </div>
        <div class="page-card-body page-wrap-960" style="padding-bottom: 20px;">
          <system-config :group="group" @cancel="cancel"></system-config>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader"
import SystemConfig from "@/components/SystemConfig"

export default {
  name: "DefaultConfig",
  data() {
    return {
      group: 'default'
    }
  },
  components: {
    PageHeader,
    SystemConfig,
  },
  created() {

  },
  mounted() {

  },
  activated() {

  },
  methods: {
    cancel() {
      this.$emit('closeView')
    },
  },
}
</script>

<style lang="scss" scoped>

</style>